<div
  edsGrid
  [edsSpacing]="(isHandheld$ | async) === false ? 'xxxl' : 'xxl'"
  edsPadding
  [edsPaddingLeft]="(isHandheld$ | async) ? 'sm' : 'none'"
  [edsPaddingRight]="(isHandheld$ | async) ? 'sm' : 'none'"
>
  <!-- breadcrumbs  area -->
  <eds-breadcrumbs
    [items]="showBreadcrumb ? breadcrumbItems : null"
    theme="basic"
    edsPadding
    edsPaddingLeft="sm"
  >
  </eds-breadcrumbs>
  <ng-container *ngIf="orderDetails$ | async as data">
    <div class="container">
      <eds-title edsSpacing="sm" size="h3" theme="basic"
        >{{ "literature.lit-order-number" | translate }}
        {{ data.orderNumber }}</eds-title
      >
      <p>
        {{ "literature.lit-order-status" | translate }} : {{ data.orderStatus }}
      </p>
      <div>
        <button
          (click)="reOrderItem(data)"
          class=""
          edsSpacing="xl"
          edsButton="primary"
        >
          {{ "literature.lit-order-reorder-btn" | translate }}
        </button>
      </div>
      <p edsSpacing="xs" class="pre-title">
        {{ "literature.lit-order-information" | translate }}
      </p>
      <div
        edsFlexbox
        [flexDirection]="(isMobile$ | async) ? 'column' : 'row'"
        justifyContent="space-between"
        edsSpacing="xl"
      >
        <div
          edsFlexItem
          flexBasis="40%"
          [edsSpacing]="(isMobile$ | async) ? 'lg' : 'none'"
        >
          <eds-title
            edsSpacing="sm"
            title="{{ 'literature.lit-order-mailing-address' | translate }}"
            size="h6"
            theme="basic"
          ></eds-title>
          <address>
            <p edsSpacing="none">
              {{ data.firstName + " " }}
              {{ data.lastName }} <br />
              {{ data.mailingAddress1 }}<br />
              <span *ngIf="data.mailingAddress2">
                {{ data.mailingAddress2 }}<br
              /></span>
              <span *ngIf="data.mailingAddress3">
                {{ data.mailingAddress3 }}<br
              /></span>
              {{ data.city }}<br />
              {{ data.zip }}<br />
            </p>
          </address>
        </div>
        <div edsFlexItem flexBasis="60%">
          <eds-title
            edsSpacing="sm"
            title="{{ 'literature.lit-order-delivery-details' | translate }}"
            size="h6"
            theme="basic"
          ></eds-title>
          <!--           <p edsSpacing="xs">Standard shipping 5-10 business days</p>
          <p edsSpacing="sm" class="text-grey1">
            For Time sensitive orde please contact customer service at 1800
          </p>
          <p edsSpacing="sm">Delivery Notes included (if any)</p> -->
          <ng-container *ngIf="isPrimericaUser; else nonPrimericaUser">
            <div
              innerHtml="{{
                'literature.lit-order-detail-delivery-information-primerica'
                  | translate
              }}"
            ></div>
          </ng-container>
          <ng-template #nonPrimericaUser>
            <div
              innerHtml="{{
                'literature.lit-order-detail-delivery-information' | translate
              }}"
            ></div>
          </ng-template>

          <p edsSpacing="none">
            {{ "literature.lit-order-date" | translate }}
            {{ data.orderDate | date: "MM/dd/yyyy" }}
          </p>
        </div>
      </div>
      <eds-title
        edsSpacing="xs"
        title="{{ 'literature.lit-order-details' | translate }}"
        size="h6"
        theme="basic"
      ></eds-title>
      <div edsFlexbox>
        <p edsPadding edsPaddingRight="sm" edsSpacing="md">
          {{ "literature.literature-cart-total-items" | translate }} :
          {{ data.titles }}
        </p>
        <p class="separator"></p>
        <p edsPadding edsPaddingLeft="sm" edsSpacing="md">
          {{ "literature.lit-order-overall-quantity" | translate }} :
          {{ data.overallQuantity }}
        </p>
      </div>

      <div edsGrid>
        <div edsRow>
          <table
            class="table table--secondary"
            #tableResponsive
            [style.display]="(isHandheld$ | async) ? 'none' : ''"
          >
            <thead class="table__thead">
              <tr class="table__tr">
                <th class="table__th">
                  {{ "literature.lit-listing-items" | translate }}
                </th>
                <th class="table__th" [style.display]="'none'">
                  {{ "literature.lit-order-status" | translate }}
                </th>
                <th class="table__th text-align-right">
                  {{ "literature.literature-overall-quantity" | translate }}
                </th>
              </tr>
            </thead>
            <tbody class="table__body">
              <tr class="table__tr" *ngFor="let fundDetail of data.document">
                <td class="table__td">
                  <eds-link-item
                    edsSpacing="md"
                    [title]="fundDetail.fundName"
                    [href]="fundDetail.itemDetailLink"
                  ></eds-link-item>
                  <span>
                    {{ "literature.lit-order-status" | translate }}:
                    {{ fundDetail.orderStatus }}
                  </span>
                </td>
                <td class="table__td" [style.display]="'none'">
                  {{ fundDetail.orderStatus }}
                </td>
                <td class="table__td text-align-right">
                  {{ "literature.lit-order-qty" | translate }}:
                  {{ fundDetail.quantity }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div edsRow *ngFor="let card of cards; let cardIndex = index">
          <div edsCol *ngIf="isHandheld$ | async">
            <eds-panel
              edsSpacing="sm"
              [hasBorders]="true"
              [hasBorderRadius]="true"
              [hasPadding]="true"
            >
              <ng-container *ngFor="let item of card; let itemIndex = index">
                <eds-info-item
                  *ngIf="itemIndex !== 0"
                  [info]="item"
                  edsSpacing="sm"
                >
                </eds-info-item>
                <ng-container *ngIf="itemIndex === 0">
                  <eds-info-item [info]="item" edsSpacing="sm">
                    {{ removeAndGetLinkValue(item) }}
                    <eds-link-item
                      edsSpacing="sm"
                      [title]="data.document[cardIndex].literatureCode"
                      href="#"
                    >
                    </eds-link-item>
                  </eds-info-item>
                </ng-container>
              </ng-container>
            </eds-panel>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</div>
